<template>
  <div class="flex flex-col items-center content-center justify-center p-5">
    <div class="w-full max-w-3xl">
      <ExternalTicketCreated />
    </div>
  </div>
</template>

<script>
import ExternalTicketCreated from '@/components/ExternalTicketCreated'

export default {
  name: 'ExternalTicketCreatedView',

  components: {
    ExternalTicketCreated
  }
}
</script>
